import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './MasterAdmin.css';

const MasterAdminLayout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="ma-container">
      <aside className="ma-sidebar">
        <div className="ma-sidebar-logo">CRM MASTER</div>
        <nav>
          <Link 
            to="/master-admin" 
            className={`ma-nav-item ${location.pathname === '/master-admin' ? 'active' : ''}`}
          >
            Dashboard
          </Link>
          <Link 
            to="/master-admin/super-admins" 
            className={`ma-nav-item ${location.pathname === '/master-admin/super-admins' ? 'active' : ''}`}
          >
            Super Admins
          </Link>
          <Link 
            to="/master-admin/subscriptions" 
            className={`ma-nav-item ${location.pathname === '/master-admin/subscriptions' ? 'active' : ''}`}
          >
            Subscriptions
          </Link>
          <Link 
            to="/master-admin/plans" 
            className={`ma-nav-item ${location.pathname === '/master-admin/plans' ? 'active' : ''}`}
          >
            Subscription Plans
          </Link>
          <Link 
            to="/master-admin/contacts" 
            className={`ma-nav-item ${location.pathname === '/master-admin/contacts' ? 'active' : ''}`}
          >
            Contact Inbox
          </Link>
          <Link 
            to="/master-admin/bug-reports" 
            className={`ma-nav-item ${location.pathname === '/master-admin/bug-reports' ? 'active' : ''}`}
          >
            Bug Reports
          </Link>
          <Link 
            to="/master-admin/email-settings" 
            className={`ma-nav-item ${location.pathname === '/master-admin/email-settings' ? 'active' : ''}`}
          >
            Email Settings
          </Link>
          <Link 
            to="/master-admin/settings" 
            className={`ma-nav-item ${location.pathname === '/master-admin/settings' ? 'active' : ''}`}
          >
            System Settings
          </Link>
        </nav>
        <button onClick={handleLogout} className="ma-btn-logout">
          Logout
        </button>
      </aside>
      <main className="ma-main">
        {children}
      </main>
    </div>
  );
};

export default MasterAdminLayout;
